// // 自定义国际化配置
// import { createI18n } from 'vue-i18n';
// // import messages from '@intlify/unplugin-vue-i18n/messages';
// // 直接引入语言包 减少打包体积
// import ar from './ar.json';
// import de from './de.json';
// import en from './en.json';
// import es from './es.json';
// import fr from './fr.json';
// import id from './id.json';
// import it from './it.json';
// import nl from './nl.json';
// import pl from './pl.json';
// import pt from './pt.json';
// import ro from './ro.json';
// import { getLanguage } from '@/utils/language';
// /**
//  * 获取当前语言
//  */
// export const i18n = createI18n({
//   globalInjection: true,
//   allowComposition: true,
//   fallbackLocale: 'en',
//   legacy: false,
//   locale: getLanguage(),
//   messages: {
//     ar,
//     de,
//     en,
//     es,
//     fr,
//     id,
//     it,
//     nl,
//     pl,
//     pt,
//     ro
//   }
// });

// // 自定义国际化配置

import { createI18n } from 'vue-i18n';
import { getLanguage } from '@/utils/language';

export const i18n = createI18n({
  globalInjection: true,
  allowComposition: true,
  fallbackLocale: 'en',
  legacy: false,
  locale: getLanguage(),
  messages: {} // 初始为空
});

/**
 * 动态加载语言包
 */
const modules: Record<string, () => Promise<any>> = import.meta.glob('./*.json');
export async function loadLanguageAsync(lang: string) {
  if (i18n.global.availableLocales.includes(lang)) {
    i18n.global.locale.value = lang;
    return;
  }
  const path = `./${lang}.json`;
  const loader = modules[path];
  const messages = await loader();
  i18n.global.setLocaleMessage(lang, messages.default);
  i18n.global.locale.value = lang;
}
